import { styled } from '@mui/material';
import { t } from 'i18next';
import { FC, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import {
  FieldsRow,
  FieldsSection,
  FormNumericField,
} from '../../../../../../../shared/components/form';

/**
 * What the columns behind the two fields hold: `RundenAuf` is `decimal(5,3)`
 * and `FaktorLtKg` is `decimal(8,3)`. Without a `max` the field allowed up to
 * 10_000_000 and MySQL rejected the save with `Out of range value for column
 * 'RundenAuf'` (WA-3899). `precision` has to follow the scale of the column,
 * since the field otherwise rounds to the company's `decimalPlacesCount` when
 * it is left - which would turn 99.999 back into 100.
 */
const ROUND_LITERS_TO_LIMIT = { max: 99.999, precision: 3 } as const;
const WEIGHT_OF_LITER_LIMIT = { max: 99999.999, precision: 3 } as const;

export const LitersSection: FC = () => {
  const { watch } = useFormContext();
  const articleDoughDataFromRA = watch('articleDoughDataFromRA');
  const isRecipeField = articleDoughDataFromRA?.intermediateWeight > 0;

  const fieldName = useMemo(
    () => (isRecipeField ? 'articleDoughDataFromRA.intermediateWeight' : 'weightOfLiterOfDough'),
    [isRecipeField],
  );

  return (
    <FieldsSection marginTop='31px' title={t('article.liters')} titleBoxSx={{ pt: 0 }} nomt>
      <FieldsRow>
        <SHiddenFormNumericPlug>
          <FormNumericField
            key='articleDoughDataFromRA.intermediateWeight'
            label={t('article.weight_of_liter_of_dough')}
            controls={false}
            noTrailingZeros={true}
            name='articleDoughDataFromRA.intermediateWeight'
            slotProps={{ input: { readOnly: true } }}
          />
          <FormNumericField
            key='weightOfLiterOfDough'
            label={t('article.weight_of_liter_of_dough')}
            controls={false}
            noTrailingZeros={true}
            name='weightOfLiterOfDough'
            {...WEIGHT_OF_LITER_LIMIT}
          />
        </SHiddenFormNumericPlug>
        <SFormNumericFieldWrapper>
          <FormNumericField
            key={fieldName}
            label={t('article.weight_of_liter_of_dough')}
            controls={false}
            noTrailingZeros={true}
            name={fieldName}
            disabled={isRecipeField}
            {...WEIGHT_OF_LITER_LIMIT}
          />
        </SFormNumericFieldWrapper>
        <FormNumericField
          label={t('article.round_to')}
          controls={false}
          noTrailingZeros={true}
          name='roundLitersTo'
          {...ROUND_LITERS_TO_LIMIT}
        />
      </FieldsRow>
    </FieldsSection>
  );
};

const SHiddenFormNumericPlug = styled('div')(() => ({
  display: 'none',
}));

const SFormNumericFieldWrapper = styled('div')(() => ({
  marginLeft: '0px !important',
}));
